import { GGOBaseComponent } from '@galigeo-store/ui-lib';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('panel-divider')
export class DividerComponent extends GGOBaseComponent {
  @property({ type: Boolean }) panelOpen = false; // Determines if the panel is open
  @property({ type: Object }) element: any = {}; // Item data (optional)
  @property({ type: String }) active: boolean = false;

  static get styles() {
    return [
      css`
        :host {
          display: block;
          padding: 0 8px;
          transition: background-color 0.3s ease;
        }
        .divider {
          border: solid 1px #E5E5E5;
          margin: 1.5rem 0;
        }
      `,
    ];
  }

  render() {
    return html`
      <div class="divider">
      </div>
    `;
  }
}